<template>
    <v-card>
        <v-card-title class="border-bottom py-2">
            <div class="font-size-16 black--text">Data Konsultan</div>
            <v-spacer />
            <v-btn icon @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pt-7 pb-6">
            <v-row>
                <v-col cols="6" class="pb-3">
                    <label class="font-size-12"> Student ID </label>
                    <v-text-field
                        v-model="detail.student_id"
                        outlined
                        readonly
                        dense
                        hide-details
                        class="mt-1"
                    />
                </v-col>

                <v-col cols="6" class="pb-3">
                    <label class="font-size-12"> Teacher ID </label>
                    <v-text-field
                        v-model="detail.teacher_id"
                        outlined
                        readonly
                        dense
                        hide-details
                        class="mt-1"
                    />
                </v-col>

                <v-col cols="6" class="pb-3">
                    <label class="font-size-12"> Start Sesi </label>
                    <v-text-field
                        v-model="start_time"
                        outlined
                        readonly
                        dense
                        hide-details
                        class="mt-1"
                    />
                </v-col>

                <v-col cols="6" class="pb-3">
                    <label class="font-size-12"> End Sesi </label>
                    <v-text-field
                        v-model="end_time"
                        outlined
                        readonly
                        dense
                        hide-details
                        class="mt-1"
                    />
                </v-col>

                <v-col cols="6" class="pb-3">
                    <label class="font-size-12"> Sesi Terpakai </label>
                    <v-text-field
                        v-model="detail.total_session"
                        outlined
                        readonly
                        dense
                        hide-details
                        class="mt-1"
                    />
                </v-col>

                <v-col cols="6" class="pb-3">
                    <label class="font-size-12"> Tambah Sesi </label>
                    <v-text-field
                        v-model="detail.add_on"
                        outlined
                        readonly
                        dense
                        hide-details
                        class="mt-1"
                    />
                </v-col>

                <v-col cols="12" class="pb-3">
                    <label class="font-size-12"> Chat Room ID </label>
                    <v-text-field
                        v-model="detail.id"
                        outlined
                        readonly
                        dense
                        hide-details
                        class="mt-1"
                    />
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions class="pb-3">
            <v-btn color="blew" dark block depressed @click="viewChatDetail()">
                Detail Chat
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "consultant-management-statistic",
    props: {
        detail: { type: Array, required: false },
    },
    data() {
        return {
            loading: false,
            form: {},
            start_time: null,
            end_time: null,
            data: [],
        };
    },

    mounted() {
        this.start_time = this.$moment(this.detail.start_time).format(
            "YYYY-MM-DD HH:mm"
        );

        this.end_time = this.$moment(this.detail.end_time).format(
            "YYYY-MM-DD HH:mm"
        );
    },

    watch: {},

    methods: {
        viewChatDetail() {
            this.$router.push(`/konsul/chat?cr_id=${this.detail.id}`);
        },
    },
};
</script>



// WEBPACK FOOTER //
// ConsulActivityDetail.vue?26116b12